export default __webpack_public_path__ + "static/media/regenz-dap-banner.d4353d08.jpg";